import { FC } from "react";
import WarningCircle from "@/components/icons/WarningCircle";
import useTranslations from "@/i18n/useTranslations";

type ErrorProps = {
  location?: string;
};

const ErrorState: FC<ErrorProps> = () => {
  const t = useTranslations("ErrorPages");

  return (
    <div className="w-full flex flex-col items-center space-y-4 mb-6">
      <div className="flex items-center gap-2">
        <span className="text-danger-500">
          <WarningCircle
            svgProps={{ viewBox: "0 0 16 16", width: "20", height: "20" }}
          />
        </span>
        <span className="font-bold elm-p4 text-center">
          {t("globalErrorTitle")}
        </span>
      </div>
      <span className="elm-p2 text-center text-putty-700 text-balance">
        {t("searchResultsErrorDescription")}
      </span>
    </div>
  );
};

export default ErrorState;
